import React, { useEffect, useState, useRef } from "react";
import "./ChatBox.css";

// REMOVED AS PART OF 19.2 UPGRADE 
//import Picker from "@emoji-mart/react";
//import data from "@emoji-mart/data";

import { jwtDecode } from "jwt-decode";
import { MentionsInput, Mention } from "react-mentions";
// import defaultMentionStyle from "./defaultMentionStyle";
import axios from "axios";

// import { jwtDecode } from "jwt-decode";

const fetchMentionUsers = async (query, callback) => {
  try {

    const instanceSlug = localStorage.getItem("instanceSlug"); // Fetch from localstorage

    const response = await axios.get(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/byinstanceUniqueId/${instanceSlug}`,
      {
        params: { name: query },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );

    console.log("Mention API response:", response.data); // ✅ This logs the raw API response

    // const users = response.data; // adjust this if your data is nested
    const users = response.data.listOfUsers || []; // ✅ Corrected this line
    const mentionList = users.map((user) => ({
      id: String(user.id),
      display:
        user.first_name && user.last_name
          ? `${user.first_name} ${user.last_name}`
          : user.username || `User #${user.id}`,
    }));

    callback(mentionList);
  } catch (error) {
    console.error("Error fetching mentions:", error);
    callback([]); // fallback empty
  }
};

function ChatBox({ webStoreId, orderId, assignedUsers, allUsers = [] }) {
  const chatBoxRef = useRef(null);
  //const emojiPickerRef = useRef(null);
  const inputRef = useRef(null);
  const [isMentioning, setIsMentioning] = useState(false);
  const [fileName, setFileName] = useState(""); // State to hold the file name

  const [file, setFile] = useState(null); // ✅ ADDED

  // Merge assignedUsers with full allUsers details
  const fullAssignedUsers = (assignedUsers || []).map((u) => {
    const found = allUsers?.find((x) => x.id === u.id);
    return found ? { ...u, ...found } : u;
  });

  // Prepare mention data: assigned first, then others
  const mentionData = [
    ...fullAssignedUsers.map((u) => ({
      id: String(u.id),
      display:
        u.first_name && u.last_name
          ? `${u.first_name} ${u.last_name}`
          : u.username || `User #${u.id}`,
    })),
    ...allUsers
      .filter((u) => !fullAssignedUsers.some((fu) => fu.id === u.id))
      .map((u) => ({
        id: String(u.id),
        display:
          u.first_name && u.last_name
            ? `${u.first_name} ${u.last_name}`
            : u.username || `User #${u.id}`,
      })),
  ];

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  // const [file, setFile] = useState(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const [uploadProgress, setUploadProgress] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [previewFileURL, setPreviewFileURL] = useState(null);

  // const getUserIdFromToken = () => {
  //   const token = localStorage.getItem("accessToken");
  //   if (token) {
  //     try {
  //       const decoded = jwtDecode(token);
  //       console.log("Decoded Token:", decoded); // Log the decoded token to check its structure
  //       return decoded.id; // Extract the user ID from the 'id' key
  //     } catch (error) {
  //       console.error("Error decoding token:", error);
  //       return null;
  //     }
  //   }
  //   return null;
  // };

  // // Usage example:
  // const userId = getUserIdFromToken();
  // console.log("User ID from token:", userId);

  function formatMessageDate(timestamp) {
    const messageDate = new Date(timestamp);
    const now = new Date();

    const diffInMs = now - messageDate;
    const diffInDays = Math.floor(diffInMs / (1000 * 3600 * 24));

    const time = messageDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    if (diffInDays === 0) {
      return "Today " + time;
    }
    if (diffInDays === 1) {
      return "Yesterday " + time;
    }

    const date = messageDate.toLocaleDateString();
    return date + " " + time;
  }

  // Fetch messages when orderId changes
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    async function fetchMessages() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/chat/messages?webStoreId=${webStoreId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = await res.json();
        setMessages(Array.isArray(data) ? data : data.messages || []);
      } catch (err) {
        console.error("Error fetching messages:", err);
        setMessages([]);
      }
    }
    if (webStoreId) {
      // Initial fetch
      fetchMessages();
      // Polling interval
      const intervalId = setInterval(fetchMessages, 8000);
      return () => clearInterval(intervalId);
    }
  }, [webStoreId]);

  // Auto-scroll to bottom on new messages
  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [messages]);

  // Decode JWT to get logged-in user ID
  function getUserId() {
    const token = localStorage.getItem("accessToken");
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      return decoded.userId || decoded.id || decoded.sub || null;
    } catch {
      return null;
    }
  }
  const UserId = getUserId();

  // Send message (with optional file name)
  async function handleSend() {
    console.log("🔔 handleSend called", { input, fileName });
    if (!input.trim() && !file) {
      console.log("✋ Nothing to send (no text, no file)");
      return;
    }

    setIsProcessing(true);
    let attachmentUrl = "";

    if (file) {
      try {
        console.log("➡️ STEP A: Requesting signed URL", {
          fileName: file.name,
          fileType: file.type,
        });
        const { data } = await axios.get(
         `${process.env.REACT_APP_NODEJS_SERVER_URL}/chat/upload-url`,
          {
            params: { fileName: file.name, fileType: file.type },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
        console.log("✅ Received signed URL", data);

        console.log("➡️ STEP B: Uploading file to S3", {
          uploadURL: data.uploadURL,
        });
        await axios.put(data.uploadURL, file, {
          headers: { "Content-Type": file.type },
          onUploadProgress: (evt) => {
            const pct = Math.round((evt.loaded * 100) / evt.total);
            console.log(`🔄 Upload progress: ${pct}%`);
            setUploadProgress(pct);
          },
        });
        console.log("✅ Upload to S3 complete");
        setUploadProgress(100);

        attachmentUrl = `https://${process.env.REACT_APP_S3_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${data.key}`;
        console.log("📎 Attachment URL:", attachmentUrl);
      } catch (err) {
        console.error(
          "❌ S3 upload error:",
          err.response || err.message || err
        );
      }
    }

    try {
      const payload = {
        //  orderId: 3456789, 
        // orderId: 3456789, // to satisfy backend for now
        webStoreId: webStoreId, // Add this line for webStoreId
        // senderId: UserId,
        message: input.trim() || "\u200B",
        ...(attachmentUrl && { attachmentUrl }),
      };
      console.log("➡️ STEP C: Sending chat payload", payload);

      const res = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/chat/messages`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      console.log("✅ Chat message posted", res.data);
      setMessages((prev) => [...prev, res.data]);
    } catch (err) {
      console.error(
        "❌ Error posting chat message:",
        err.response || err.message || err
      );
    } finally {
      setTimeout(() => {
        console.log("🔄 Resetting UI state");
        setUploadProgress(null);
        setIsProcessing(false);
        setFile(null);
        setFileName("");
        setInput("");
        setPreviewFileURL(null);
        const fileInput = document.getElementById("file-upload");
        if (fileInput) fileInput.value = "";
      }, 500);
    }
  }

  // File selection handler
  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setFileName(file.name); // Store the selected file's name
  //     setInput((prevInput) => `${prevInput} ${file.name}`); // Add file name to input field
  //   }
  // };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);

      // Generate preview URL
      const previewURL = URL.createObjectURL(selectedFile);
      setPreviewFileURL(previewURL); // <-- make sure you've declared this state
    }
  };

  // Emoji insertion
  function addEmoji(emoji) {
    setInput((prev) => prev + emoji.native);
  }

  // Render message text, turning "@[Name](id)" into a pill
  function highlightText(text) {
    const pattern = /@\[(.+?)\]\((\d+)\)/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    while ((match = pattern.exec(text)) !== null) {
      parts.push(text.slice(lastIndex, match.index));
      parts.push(
        <span key={match.index} className="mention-pill">
          @{match[1]}
        </span>
      );
      lastIndex = pattern.lastIndex;
    }
    parts.push(text.slice(lastIndex));
    return parts;
  }

  // const parseMentions = (text) => {
  //   const mentionRegex = /@\[([^\]]+)\]\(([^)]+)\)/g;
  //   let lastIndex = 0;
  //   let htmlContent = "";

  //   let match;
  //   while ((match = mentionRegex.exec(text)) !== null) {
  //     const [fullMatch, username, id] = match;
  //     const start = match.index;

  //     // Append the text before the mention
  //     htmlContent += text.slice(lastIndex, start);

  //     // Append the mention as a styled span
  //     htmlContent += `<span class="mentions__mention">@${username}</span>`;

  //     lastIndex = start + fullMatch.length;
  //   }

  //   // Append any remaining text
  //   htmlContent += text.slice(lastIndex);
  //   return htmlContent;
  // };

  console.log("mentionData", mentionData); // ✅ Add here
  return (
    <div className="chat-container">
      <h3 className="chat-header">Team Chat - Webstore #{webStoreId}</h3>

      <div className="chat-box" ref={chatBoxRef}>
        {messages.map((msg, i) => {
          const senderName =
            msg.User?.first_name && msg.User?.last_name
              ? `${msg.User.first_name} ${msg.User.last_name}`
              : "Unknown User";
          const display = msg.User?.id === UserId ? "You" : senderName;

          return (
            <div
              key={i}
              className={`chat-message-wrapper ${
                display === "You" ? "you" : "other"
              }`}
            >
              <div
                className={`chat-message ${
                  display === "You" ? "you" : "other"
                }`}
              >
                {display !== "You" && (
                  <div className="message-header">
                    <span className="chat-sender">{display}</span>
                  </div>
                )}

                <div className="chat-body">
                  {msg.attachmentUrl && (
                    <div className="chat-file">
                      <a
                        href={msg.attachmentUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="chat-file-link"
                        // title="Open Attachment"
                        title={msg.attachmentUrl
                          .split("/")
                          .pop()
                          .split("_")
                          .slice(1)
                          .join("_")} // 👈 this shows full file name on hover
                      >
                        📄Click to view or download
                      </a>
                    </div>
                  )}

                  <div className="chat-message-wrapper">
                    <div className="chat-message">
                      <div className="chat-text-time">
                        <div className="chat-text">
                          {highlightText(msg.message)}
                        </div>
                        <div className="chat-time">
                          {formatMessageDate(msg.createdAt)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* // 👇 ADD PROGRESS BAR HERE */}
      {/* {uploadProgress !== null && (
  <div className="w-full px-4 mt-2">
    <p className="text-sm text-gray-600 mb-1">Uploading: {fileName}</p>
    <div className="w-full h-2 bg-gray-200 rounded">
      <div
        className="h-full bg-blue-500 rounded transition-all duration-300"
        style={{ width: `${uploadProgress}%` }}
      />
    </div>
  </div>
)} */}

      <div className="chat-input-section">
        {/* Show Upload Progress Bar */}
        {uploadProgress !== null && uploadProgress < 100 && (
          <div className="upload-progress-bar">
            <p className="upload-text">
              Uploading: {fileName} ({uploadProgress}%)
            </p>
            <div className="upload-bar-bg">
              <div
                className="upload-bar-fg"
                style={{ width: `${uploadProgress}%` }}
              />
            </div>
          </div>
        )}

        {/* Show Preview + Spinner when upload is complete but response not received */}
        {uploadProgress === 100 && isProcessing && previewFileURL && (
          <div className="preview-uploading-container">
            {file && file.type.startsWith("image/") ? (
              <>
                <img
                  src={previewFileURL}
                  alt="Preview"
                  className="preview-image"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
                <div className="spinner-overlay">
                  <span className="spinner" />
                </div>
              </>
            ) : (
              <>
                <div className="file-icon-container">
                  <span>📄 {file?.name}</span>
                </div>
                <div className="spinner-overlay">
                  <span className="spinner" />
                </div>
              </>
            )}
          </div>
        )}

        <div className="input-container">
          <button
            className="icon-button"
            onClick={(e) => {
              e.stopPropagation();
              //setShowEmojiPicker((v) => !v);
            }}
          >
            😀
          </button>
          { /* REMOVED AS PART OF 19.2 UPGRADE */ }
          {/*showEmojiPicker && (
            <div className="emoji-picker" ref={emojiPickerRef}>
              <Picker data={data} onEmojiSelect={addEmoji} />
            </div>
          )*/}

          <label htmlFor="file-upload" className="icon-button" title="Attach">
            <span className="material-icons">attach_file</span>
          </label>
          <input
            id="file-upload"
            type="file"
            accept=".jpg,.jpeg,.png,.webp,.pdf,.doc,.docx"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />

          {/* {fileName && (
            <div className="file-name-display">
              <p>Selected file: {fileName}</p>{" "} */}
          {/* ✅ This now appears inside the input box section */}
          {/* </div>
          )} */}

          {fileName && (
            <div className="attached-file-chip">
              📎 {fileName}
              <span
                className="remove-chip"
                onClick={() => {
                  setFile(null);
                  setFileName("");
                }}
              >
                ❌
              </span>
            </div>
          )}

          <div className="message-input-wrapper">
            <MentionsInput
              value={input}
              onChange={(e, v) => {
                setInput(v);
                if (v.includes("@")) {
                  console.log("Mention detected:", v);
                }
              }}
              placeholder="Type a message..."
              className="mentions"
              inputRef={inputRef}
              onKeyDown={(e) => {
                if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                  setIsMentioning(true);
                }
                if (e.key === "Enter" && !e.shiftKey) {
                  if (isMentioning) {
                    setIsMentioning(false); // Complete the mention
                    return;
                  }
                  // if (!e.shiftKey) {
                  e.preventDefault();
                  // handleSend();
                  // }
                }
              }}
            >
              <Mention
                trigger="@"
                data={fetchMentionUsers}
                markup="@[__display__](__id__)"
                displayTransform={(id, display) => `@${display}`}
                mentionClassName="mentions__mention"
                onAdd={() => setIsMentioning(false)}
                renderSuggestion={(suggestion, search, highlighted) => (
                  <div
                    className={`mention-suggestion-item ${
                      fullAssignedUsers.some(
                        (u) => String(u.id) === suggestion.id
                      )
                        ? "assigned"
                        : ""
                    }`}
                  >
                    {highlighted}
                    {fullAssignedUsers.some(
                      (u) => String(u.id) === suggestion.id
                    ) && <span className="assigned-badge">Assigned</span>}
                  </div>
                )}
              />
            </MentionsInput>

            {/* Display the file name below the input */}
            {/* {fileName && <div className="file-name-display">📎 {fileName}</div>} */}
          </div>

          <button className="send-button" onClick={handleSend}>
            <span className="material-icons">send</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChatBox;
